import { Navigate, Route, Routes } from 'react-router-dom';

import { NotFound } from '@/components/molecules/NotFound';

import { usePermissions } from '../contexts/auth';

import Clients from './Clients';
import Internal from './Internal';

/** The signed-out pages, which a signed-in user is sent past to the start page. */
const PUBLIC_PATHS = [
    '/login',
    '/login2',
    '/reset-password-request',
    '/reset-password-request2',
    '/reset-password',
    '/reset-password2',
    '/register',
];

export default function LoggedInRoutes() {
    const { isOptoScaleAdmin } = usePermissions();
    const home = <Navigate to={isOptoScaleAdmin ? '/internal' : '/c'} replace />;

    return (
        <Routes>
            {isOptoScaleAdmin && <Route path="/internal/*" element={<Internal />} />}
            <Route path="/c/*" element={<Clients />} />
            <Route index element={home} />
            {PUBLIC_PATHS.map((path) => (
                <Route key={path} path={path} element={home} />
            ))}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
